import { useState, useEffect, useRef } from "react";
export default function OurMission() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const cards = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/mission_quality.png",
    alt: "Clinician using a modern precision tablet interface to adjust custom fitted medical equipment structure",
    heading: "Quality and innovation",
    body: "We deliver the highest quality medical equipment by harnessing the latest innovations and ongoing research. Our products are built to exceed industry standards."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/mission_healing.png",
    alt: "Older individual happily gardening in a sunlit outdoor area with complete independence",
    heading: "Healing and independence",
    body: "We empower patients to manage their conditions at home through custom-fit equipment that supports independence and a higher quality of life."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/mission_community.png",
    alt: "A patient and family member sharing a happy, smiling conversation in a warm, daylight-filled room",
    heading: "Compassionate community",
    body: "We are more than a provider — we are a partner. Empathy, education, and supportive customer service define how we show up for every patient and family."
  }];
  return <section id="OurMission" style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    animation: "none 0s ease 0s 1 normal none running"
  }} className="w-full">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Inter:wght@300;400;600&display=swap');`}</style>

      <div className="px-4 md:px-8" style={{
      paddingTop: "128px",
      paddingBottom: "128px"
    }}>
        <div style={{
        paddingTop: "96px",
        paddingBottom: "96px"
      }} className="hidden" />

        <div className="page-container">
          <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="flex flex-col items-center text-center mb-14">
              <span style={{
              color: "#E51F26",
              fontFamily: "Inter, system-ui, -apple-system, sans-serif",
              fontSize: "12px",
              fontWeight: "600",
              letterSpacing: "0.1em",
              textTransform: "uppercase"
            }} className="mb-2">
                WHAT DRIVES US
              </span>

              <h2 style={{
              color: "rgb(26, 26, 26)",
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              fontSize: "48px",
              fontWeight: "500",
              lineHeight: "48px",
              letterSpacing: "-1.2px",
              border: "0px solid rgb(26, 26, 26)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running"
            }} className="mt-2 mb-4">
                Our mission.
              </h2>

              <div style={{
              width: "40px",
              height: "2px",
              backgroundColor: "#E51F26",
              borderRadius: "0px"
            }} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {cards.map((card, i) => <div key={i} data-index={i} className="flex flex-col" style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  <div className="overflow-hidden">
                    <img src={card.image} data-wvc-srcset={`${card.image}-wvc-srcset`} data-wvc-sizes={`${card.image}-wvc-sizes`} alt={card.alt} loading="lazy" className="w-full h-auto object-cover" style={{
                  aspectRatio: "4/3"
                }} />
                  </div>

                  <div className="mt-5">
                    <h3 style={{
                  color: "rgb(26, 26, 26)",
                  fontFamily: '"Cormorant Garamond", Georgia, serif',
                  fontSize: "24px",
                  fontWeight: "400",
                  lineHeight: "32px",
                  letterSpacing: "-0.6px",
                  border: "0px solid rgb(26, 26, 26)",
                  animation: "none 0s ease 0s 1 normal none running"
                }} className="mb-2">
                      {card.heading}
                    </h3>

                    <p style={{
                  color: "oklch(0.551 0.027 264.364)",
                  fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                  fontSize: "14px",
                  fontWeight: "300",
                  lineHeight: "22.75px",
                  border: "0px solid oklch(0.551 0.027 264.364)",
                  animation: "none 0s ease 0s 1 normal none running"
                }}>
                      {card.body}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}